// extracted by mini-css-extract-plugin
export var tosLink = "_4f-0";